import moment from 'moment';

function directive($interval, $location, $state, $window) {
    return {
        link: function ($scope, element, attrs) {
            // moved this section from the controller
            let model = this;
            if (!($state.current.data.daterange)) { return } // do nothing if time already exists
            // we'll have to poll the main controller to check for updated times
            let timer;
            model.setDisplayValues = function (unixTimeObject) {
                $scope.dateRangeStart = moment.unix(unixTimeObject.start).format('MMMM D, YYYY h:mm A');
                $scope.dateRangeEnd = moment.unix(unixTimeObject.end).format('MMMM D, YYYY h:mm A');
            }
            model.setDisplayTimer = function () {
                if (!($location.$$search.hasOwnProperty('start')) && !($location.$$search.hasOwnProperty('end'))) {
                    timer = $interval(function () {
                        let time = $scope.main.getTime();
                        model.setDisplayValues(time);
                    }, 1000);
                } else {
                    if (angular.isDefined(timer)) {
                        $interval.cancel(timer);
                        timer = undefined;
                    }
                }
            };
            // get inital times from main function
            let time = $scope.main.getTime();
            // apply them to visual
            model.setDisplayValues(time);
            // start timer if applicable
            model.setDisplayTimer();
            // kill all timers on state destroy
            $scope.$on('$destroy', function () {
                if (angular.isDefined(timer)) {
                    $interval.cancel(timer);
                    timer = undefined;
                }
            });


            var daterangepicker = require('bootstrap-daterangepicker');
            // run nothing else if daterange is false or undefined
            if (!($state.current.data.daterange)) { return }
            $('#daterange').daterangepicker(
                {
                ranges: {
                    'Today': [moment().startOf('day'), moment()],
                    'Yesterday': [moment().subtract(1, 'days').startOf('day'), moment().subtract(1, 'days').endOf('day')],
                    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                    'This Month': [moment().startOf('month'), moment().endOf('month')],
                    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                },
                    format: 'MMMM D, YYYY h:mm A',
                    timePicker: true,
                    timePickerIncrement: 5
                },
                function (start, end) {
                    // update the time in main
                    $scope.main.setTime({
                        start: moment(start).unix(),
                        end: moment(end).unix()
                    }).then(function (time) {
                        // then set the url to our new time
                        let search = $location.$$search;
                        search.start = time.start;
                        search.end = time.end;
                        $location.search(search);
                        // tell timer to check for updates to url
                        $scope.main.resetTimer();
                        // run display check function
                        model.setDisplayTimer();
                        // assign the time value to our visual
                        model.setDisplayValues(time);
                        // update data

                        // let current = $state.current.name;
                        // $state.go($state.current, angular.copy({start: search.start, end:search.end}), { reload: false, inherit: false, notify: true });
                        setTimeout(function(){
                            $window.location.reload();
                        },1000);
                    })
                }
            );
            $scope.$on('$destroy', function () {
                element.remove();
            });
        }
    };
}

directive.$inject = ['$interval', '$location', '$state', '$window'];
module.exports = directive;


/** WEBPACK FOOTER **
 ** ./src/pages/directives/datepicker/datepicker.js
 **/